import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { filter, withLatestFrom } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';

// store
import { Store } from '@ngrx/store';
import * as fromStore from '@app/store/auth';
import { AppState } from './store/state';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title = 'sb-admin-angular';
    constructor(public router: Router, private activatedRoute: ActivatedRoute, private store: Store<AppState>) {
        // this.router.events
        //     .pipe(filter(event => event instanceof ChildActivationEnd))
        //     .subscribe(event => {
        //         let snapshot = (event as ChildActivationEnd).snapshot;
        //         while (snapshot.firstChild !== null) {
        //             snapshot = snapshot.firstChild;
        //         }
        //         this.titleService.setTitle(snapshot.data.title || 'SB Admin Angular');
        //     });

        const navEnd$ = this.router.events.pipe(filter((e) => e instanceof NavigationEnd));

        navEnd$.pipe(withLatestFrom(this.activatedRoute.queryParams)).subscribe(async ([navEnd, queryParams]) => {
            const currentRoute = this.router.url.split('?')[0];

            if (currentRoute === '/') {
                this.router.navigateByUrl('login');
            }

            if (currentRoute === '/login') {
                if (queryParams.session) {
                    const sessionToken: string = queryParams.session;

                    this.store.dispatch(fromStore.LogInWithSession({ payload: sessionToken }));
                } else {
                    this.router.navigateByUrl('login');
                }
            }
        });
    }
}
